import { forwardRef, ReactNode } from 'react';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';

export interface AppBarIconButtonProps {
  children: ReactNode;
  variant?: 'dense' | string;
  dense?: boolean;
}

interface AppBarIconButtonRootProps {
  dense?: boolean;
}

const AppBarIconButtonRoot = styled(IconButton, {
  name: 'O2AppBar',
  slot: 'IconButton',
  shouldForwardProp: (prop) => prop !== 'dense',
})<AppBarIconButtonRootProps>(({ theme, dense }) => ({
  borderRadius: 0,
  alignSelf: 'stretch',
  padding: `0 ${theme.spacing(1.25)}`,
  ...(!dense && {
    [theme.breakpoints.up('sm')]: {
      padding: `0 ${theme.spacing(2)}`,
    },
  }),
}));

const AppBarIconButton = forwardRef<HTMLButtonElement, AppBarIconButtonProps>((props, ref) => {
  const { variant, dense, ...other } = props;

  return (
    <AppBarIconButtonRoot
      ref={ref}
      dense={variant === 'dense' || dense}
      color="inherit"
      centerRipple={false}
      {...other}
    >
      {props.children}
    </AppBarIconButtonRoot>
  );
});

AppBarIconButton.displayName = 'AppBar.IconButton';
export default AppBarIconButton;
